import { useEffect } from "react";
import { CONFIG } from "@/config";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const JSONLD_ID = "page-jsonld";

export const usePageMeta = ({ title, description, path = "/", jsonLd = null, noSuffix = false }) => {
  useEffect(() => {
    const full = title ? (noSuffix ? title : `${title} | ${CONFIG.brand}`) : `${CONFIG.brand} | ${CONFIG.tagline}`;
    const url = `${CONFIG.website}${path}`;
    document.title = full;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", full);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", full);
    setMeta('meta[name="twitter:description"]', "content", description);

    let script = document.getElementById(JSONLD_ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = JSONLD_ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, jsonLd, noSuffix]);
};
